import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotDeliveriesComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotDeliveries',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#A26AFF",
    d: "M2 5.49a2 2 0 0 1 2-2h8a1 1 0 0 1 1 1v13H4a2 2 0 0 1-2-2v-10Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M13 5.49h5.495a2 2 0 0 1 1.83 1.194l1.506 3.42a2 2 0 0 1 .169.806v4.58a2 2 0 0 1-2 2h-7v-12Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M17.307 20.51a3.198 3.198 0 0 0 3.196-3.2c0-1.768-1.431-3.2-3.196-3.2a3.198 3.198 0 0 0-3.195 3.2c0 1.767 1.43 3.2 3.195 3.2Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M17.307 18.8a1.489 1.489 0 1 0-.002-2.982 1.489 1.489 0 0 0 .002 2.981Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M6.413 20.5a3.228 3.228 0 0 0 3.225-3.23 3.228 3.228 0 0 0-3.225-3.23 3.228 3.228 0 0 0-3.226 3.23 3.228 3.228 0 0 0 3.226 3.23Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#D2A4FF",
    d: "M6.413 18.76a1.489 1.489 0 1 0-.002-2.982 1.489 1.489 0 0 0 .002 2.981Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#8D48FF",
    d: "M14.5 10.49v-3a.5.5 0 0 1 .5-.5h3.673a.5.5 0 0 1 .458.299l1.313 3a.5.5 0 0 1-.459.7H15a.5.5 0 0 1-.5-.5Z"
  }));
};
SpotDeliveriesComponent.displayName = 'SpotDeliveries';
export var SpotDeliveries = withProvisionalOverrideFromContext(SpotDeliveriesComponent);
//# sourceMappingURL=index.js.map